<ng-container *ngIf="employees$ | async as employees">
  <ng-container *ngIf="employees.length; else loading">
    <video autoplay muted loop class="about-video">
      <source [src]="assets_base_path + '/assets/agingplan/about-page/AgingPlan_LightBackground.mp4'" type="video/mp4" />
      <track  kind="captions" srclang="en" label="English">
    </video>

    <div class="container">
      <lib-heading #heading heading="OUR TEAM" subheading="Talented, Dedicated" [lucid]="true" class="mt-2">
        <p #paragraph>
          AgingPlan is fortunate to have an amazingly talented and dedicated team. Each individual brings their own unique abilities to serve our clients. Every team member has personally experienced
          the challenges associated with caregiving, which gives them a unique and empathetic perspective in the work they do. They each have an enormous amount of drive to contribute to our mission.
        </p>
      </lib-heading>

      <div #employeesContainer class="employee mx-auto">
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 m-0">
          <ng-container *ngFor="let employee of employees; let i = index">
            <div class="col">
              <a [routerLink]="['./employee', i]">
                <img *ngIf="employee.small_image_url" [src]="assets_employee_path + employee.small_image_url" alt="employee_image"  width="310" height="174"/>

                <div class="text-wrapper">
                  <div class="name">{{ employee.name }}</div>
                  <div class="title">{{ employee.title }}</div>
                </div>
              </a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #loading>
  <loading></loading>
</ng-template>
